import React, { useContext } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MoneyApiForm } from "go-core/api/types";
import FormMoneyInput from "go-form/components/FormMoneyInput";
import { OrderContext } from "../../../contexts/OrderContext";

interface Props {
	form: UseFormReturn<{ tip: MoneyApiForm }>;
}

const CustomTipInput = ({ form }: Props) => {
	const { order } = useContext(OrderContext);
	const { t } = useTranslation();
	const { control } = form;
	const currency = order?.to_pay?.currency ?? "";

	return (
		<div className="w-100 mt-2 custom-tip-input-container">
			<FormMoneyInput
				name="tip.amount"
				control={control}
				errors={[]}
				suffix=""
				currency={currency}
				placeholder={`${t("modules.e_order.field.tip_amount.title")} (${currency}) *`}
			/>
		</div>
	);
};

export default CustomTipInput;
